import { render, staticRenderFns } from "./NoPermissionsPage.vue?vue&type=template&id=718cf19a"
import script from "./NoPermissionsPage.vue?vue&type=script&lang=js"
export * from "./NoPermissionsPage.vue?vue&type=script&lang=js"
import style0 from "./NoPermissionsPage.vue?vue&type=style&index=0&id=718cf19a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports